@if (result(); as item) {
  <div class="flex flex-col gap-0.5">
    <div class="flex flex-row text-sm color-primary">
      <span>{{item[0]}}</span>
    </div>
    <div class="flex flex-row">
      <span class="font-bold">{{item[1]}}</span>
    </div>
  </div>
}

